import styled from 'styled-components'
import { resetButton } from '../../primitives/Button/Button'
import { theme } from '../../styles/theme'

export const LangButtonsContainer = styled.div`
  display: inline-block;
  margin-right: 20px;
  font-size: 12px;
`

export const LangButton = styled.button<{ active?: boolean }>`
  ${resetButton};
  text-transform: uppercase;
  text-decoration: ${props => props.active ? 'underline' : 'none'};

  &:hover {
    color: ${theme.colors.error}
  }
`